export default __webpack_public_path__ + "static/media/git.8cf99c1e.svg";